import React from "react";
import { Container, Header, Grid } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { GoogleApiWrapper } from "google-maps-react";
import { Config } from "../../data/config";
import { setTitle, setMetaDescription } from "../../util";
import MessageModal from "./MessageModal";

class Support extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      messageModal: false,
    };

    this.closeMessageModal = this.closeMessageModal.bind(this);
    this.openMessageModal = this.openMessageModal.bind(this);
  }

  openMessageModal(e) {
    e.preventDefault();
    this.setState({
      messageModal: true,
    });
  }

  closeMessageModal() {
    this.setState({
      messageModal: false,
    });
  }

  componentDidMount() {
    document.title = setTitle(this.props.title);
    setMetaDescription(this.props.description);
  }

  render() {
    const { messageModal } = this.state;
    return (
      <section className="space support">
        <Container>
          <Header as="h1" className="display-1 text-uc" textAlign="center">
            Support
          </Header>
          <h2 className="ui itc-std-md normal text-black centered grid f-size--24 mx-auto my-0 ">
            For sales, billing and support, here's how can you reach us
          </h2>

          <Grid columns={4} className="support__footer stackable">
            <Grid.Column>
              <div>
                <Header size="tiny">Send us a Message</Header>
                <a className="cursor-pointer" onClick={this.openMessageModal}>
                  Send us a message
                </a>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div>
                <Header size="tiny">By Phone</Header>
                <a href="tel:(888) 316-5813">(888) 316-5813</a>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div>
                <Header size="tiny">Customer Portal</Header>
                <a 
                  href="https://my.beanfield.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Sign in to portal
                </a>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div>
                <Header size="tiny">Frequently asked questions</Header>
                <Link to={"faqs"}>
                  <u>View our FAQs</u>
                </Link>
              </div>
            </Grid.Column>
            <Grid.Column>
              <div>
                <Header size="tiny">Support Centre</Header>
                <a href="https://support.fibrestream.ca/">Visit for help</a>
              </div>
            </Grid.Column>
          </Grid>
        </Container>

        <MessageModal
          open={messageModal}
          closeMessageModal={this.closeMessageModal}
        />
      </section>
    );
  }
}

Support = GoogleApiWrapper({
  apiKey: Config.apiKey,
})(Support);

export default Support;



// WEBPACK FOOTER //
// ./src/components/support/Support.js